import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLinesInView } from "@/components/Reveal";

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative bg-blue text-cream grain overflow-hidden">
      <div className="container-editorial relative z-10 py-28 md:py-40 text-center">
        <Reveal>
          <p className="eyebrow text-amber-bright mb-8">One Advisor. One Fee. One Journey.</p>
        </Reveal>
        <MaskLinesInView
          lines={["The question isn't whether you", "can afford this guidance;"]}
          className="font-serif font-bold text-4xl md:text-6xl lg:text-7xl leading-[1.05] text-cream"
          stagger={0.1}
        />
        <MaskLinesInView
          lines={["it's whether you can afford", "to proceed without it."]}
          className="font-serif font-bold italic text-4xl md:text-6xl lg:text-7xl leading-[1.05] text-amber-bright mt-2"
          stagger={0.1}
        />
        <Reveal delay={0.2}>
          <div className="mt-14 flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/contact"
              data-testid="cta-book-consultation"
              className="group relative overflow-hidden bg-amber-deep text-cream px-9 py-4 eyebrow text-xs flex items-center gap-2"
            >
              <span className="relative z-10 flex items-center gap-2">
                Book a Consultation <ArrowUpRight size={16} />
              </span>
              <span className="absolute inset-0 bg-cream translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]" />
              <span className="absolute inset-0 flex items-center justify-center gap-2 text-blue opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-150 eyebrow text-xs z-20 pointer-events-none">
                Book a Consultation <ArrowUpRight size={16} />
              </span>
            </Link>
            <Link
              to="/services"
              data-testid="cta-explore-journey"
              className="eyebrow text-xs text-cream/80 hover:text-amber-bright link-underline transition-colors"
            >
              Explore the Journey
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
